import { atom } from "recoil";

export const isModalAtom = atom({
  key: "isMocalopen",
  default: false,
});

export const idxAtom = atom({
  key: "clickedIdx",
  default: "",
});
